module.exports = require('./helpers/bundle-url').getBundleURL('49u2Q') + require('./helpers/bundle-manifest').resolve("lyD5y");